import React from 'react';

// Partnership Management - Commissions (User Management CSS)
const CommissionsTab = () => {
  return (
    <div className="tab-content">
      <div className="user-controls">
        <div className="search-box">
          <input type="text" placeholder="Search partners or students" />
          <span className="material-icons">search</span>
        </div>
        <select className="partnership-filter-select" defaultValue="all">
          <option value="all">All Statuses</option>
          <option value="pending">Pending</option>
          <option value="paid">Paid</option>
        </select>
      </div>

      <table className="users-table">
        <thead>
          <tr>
            <th>Partner</th>
            <th>Student</th>
            <th>Subscription</th>
            <th>Commission Amount</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Example Teacher</td>
            <td>Student Name</td>
            <td>Educational - High School</td>
            <td>$5.00</td>
            <td>Pending</td>
            <td>2025-01-01</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CommissionsTab;

